'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui';
import { Alert } from '@repo/ui/icons';
import { AnimatePresence, motion, MotionConfig, type Variants } from 'motion/react';
import { useEffect, useRef, useState } from 'react';
import { useWeb3Context } from '@/contexts/Web3Context';
const TRANSITION_CONFIG = {
  duration: 0.25,
  type: 'spring',
  bounce: 0
} as const;
const wrongNetworkVariants: Variants = {
  initial: {
    opacity: 0,
    filter: 'blur(4px)',
    scale: 0.9
  },
  animate: {
    opacity: 1,
    filter: 'blur(0px)',
    scale: 1
  },
  exit: {
    opacity: 0,
    filter: 'blur(4px)',
    scale: 0.9
  }
};

/**
 * Displays a wrong-network warning button in the nav bar on chain-specific pages
 * (vault/market detail) when the user's wallet is connected to a different chain.
 * Hidden on multi-chain pages and for Safe App users.
 */
export function WrongNetworkButton() {
  const $ = _c(8);
  const {
    account,
    switchToTargetChain,
    isMultiChainPage
  } = useWeb3Context();
  const [displayWrongNetwork, setDisplayWrongNetwork] = useState(false);
  const timeout = useRef(null);
  let t0;
  let t1;
  if ($[0] !== account.isWrongChain) {
    t0 = () => {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
      if (account.isWrongChain) {
        timeout.current = setTimeout(() => {
          setDisplayWrongNetwork(true);
        }, 1200);
      } else {
        setDisplayWrongNetwork(false);
      }
      return () => {
        if (timeout.current) {
          clearTimeout(timeout.current);
        }
      };
    };
    t1 = [account.isWrongChain];
    $[0] = account.isWrongChain;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  if (isMultiChainPage || account.isSafe) {
    return null;
  }
  let t2;
  if ($[3] !== displayWrongNetwork || $[4] !== switchToTargetChain) {
    t2 = displayWrongNetwork && <motion.div variants={wrongNetworkVariants} initial="initial" animate="animate" exit="exit" key="wrong-network-nav"><Tooltip><TooltipTrigger asChild={true}><Button variant="destructive" size="iconMd" aria-label="You are connected to the wrong network" onClick={switchToTargetChain}><Alert /></Button></TooltipTrigger><TooltipContent>You are connected to the wrong network</TooltipContent></Tooltip></motion.div>;
    $[3] = displayWrongNetwork;
    $[4] = switchToTargetChain;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <MotionConfig transition={TRANSITION_CONFIG}><AnimatePresence>{t2}</AnimatePresence></MotionConfig>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}